export default {
  mediaFiles: '媒体文件',
  annotation: '标注',
  loadingImage: '加载图片...',
  missingImageParams: '缺少图片参数，无法进入标注',
  modelTraining: '模型训练',
  submitCurrentImageConfirm: '将提交当前图片用于模型训练，如有未保存的修改会先自动保存。是否继续？',
  submit: '提交',
  cancel: '取消',
  addAnnotationFirst: '请先添加标注再提交模型训练',
  missingJobInfo: '缺少作业信息，无法提交训练',
  modelTrainingSubmitted: '已提交模型训练',
  viewTrainingTask: '查看训练任务',
  batchModelTraining: '批量模型训练',
  batchSubmitConfirm: '将提交已选 {count} 张图片用于模型训练，如有未保存的修改会先自动保存。是否继续？',
  selectImagesFirst: '请先勾选要参与训练的图片',
  annotationSaved: '标注已保存',
  saveFailed: '保存失败',
  submitTrainingFailed: '提交训练失败',
  selectAll: '全选',
  deselectAll: '取消全选',
  modelTrainingCount: '模型训练 ({count})',
  folderEmpty: '本文件夹暂无可标注图片',
  toolbarPan: '平移画布',
  toolbarDrawRect: '绘制矩形',
  toolbarDrawPolygon: '绘制多边形',
  toolbarAiSelect: 'AI 点选识别',
  toolbarUndo: '撤销 (Ctrl+Z)',
  toolbarRedo: '重做 (Ctrl+Y)',
  toolbarResetHint: '重置为打开图片时的标注',
  toolbarZoomIn: '放大',
  toolbarFitViewport: '适应窗口',
  toolbarZoomOut: '缩小',
  resetAnnotations: '重置标注',
  resetAnnotationsConfirm: '将恢复为打开当前图片时的标注状态，当前未保存的修改会丢失。是否继续？',
  reset: '重置',
  listTitle: '标注列表',
  noLabelSelected: '未选择标签',
  delete: '删除',
  selectLabel: '选择标签',
  listEmpty: '暂无标注',
  shapeRectangle: '矩形',
  shapePolygon: '多边形',
  originAi: 'AI',
  originManual: '手动',
  saveAnnotations: '保存标注',
  selectLabelPlease: '请选择标签',
  noLabels: '暂无标签',
  unannotated: '未标注',
  searchAndSelectLabel: '搜索并选择标签',
  confirmLabel: '确认',
  confirmDefaultLabelHint: '已预选上次标签，按 Enter 或点击确认',
  aiRecognizing: '识别中...',
  aiPromptHint: '点击空白添加正向点（绿），预览内点击添加负向点（红）；悬停已有提示点可删除',
  aiPromptCount: '已添加 {count} 个提示点',
  aiCandidateScore: '置信度 {score}%',
  aiCandidateOption: '候选 {index}',
  aiSavePrediction: '保存',
  selectTrainingModel: '训练模型',
  selectTrainingModelPlaceholder: '请选择要训练的模型',
  selectTrainingModelPlease: '请选择训练模型',
  selectTrainingVideo: '训练视频',
  selectTrainingVideoPlaceholder: '请选择用于训练的视频',
  selectTrainingVideoPlease: '请选择训练视频',
  noTrainingVideoAvailable: '当前文件夹没有可用于训练的视频（需为未 detected 的 .mp4）',
  unsavedChangesTitle: '未保存的标注',
  unsavedChangesContent: '当前图片有未保存的标注修改，是否保存后再继续？',
  saveAndContinue: '保存并继续',
  discardChanges: '不保存',
}